import { fromEnv, string } from '@/lib/vue-dynamic-config';

export type AppConfig = {
  imagesServerHost: string;
  casinoPlayUrl: string;
  baseUrl: string;
  ecoAuthApiPrefix: string;
}

let config: AppConfig | undefined;

export const useConfig = (): AppConfig => {
  if (config === undefined) {
    config = {
      imagesServerHost: fromEnv({
        key: 'VUE_APP_IMAGES_SERVER_HOST',
        parser: string,
      }),
      casinoPlayUrl: fromEnv({
        key: 'VUE_APP_CASINO_PLAY_URL',
        parser: string,
      }),
      baseUrl: fromEnv({
        key: 'VUE_APP_BASE_URL',
        defaultValue: '',
        parser: string,
      }),
      ecoAuthApiPrefix: fromEnv({
        key: 'VUE_APP_ECO_AUTH_API_PREFIX',
        parser: string,
      }),
    };
  }

  return config;
};
